
// src/index.js
import TextBuilder from 'ol/render/canvas/TextBuilder.js';
import MyTextBuilder from './render/canvas/TextBuilder.js';

// Replace the method
TextBuilder.prototype.drawText = MyTextBuilder.prototype.drawText;

// index.js
import * as layer from './layer.js';
import * as control from './control.js';
import * as interaction from './interaction.js';
import * as source from './source.js';
import * as format from './format.js';
import {default as extent} from './extent.js';
import * as utils from './utils.js';
import {default as proj} from './proj.js';
import * as style from './style.js';
import * as geom from './geom.js';
import {default as sphere} from './sphere.js';
import {default as events} from './events.js';
import * as coordinate from './coordinate.js';
import * as legend from './legend.js';
import {default as tilegrid} from './tilegrid.js';
import {default as proj4} from './proj/proj4.js';
import {default as loadingstrategy} from './loadingstrategy.js';
import {default as render} from './render.js';
import LRUCache from 'ol/structs/LRUCache.js';
import * as util from 'ol/util';

// constants utilities
import constants, { set, get, has, remove } from './constants.js';

import {default as Collection} from './Collection.js';
import {default as Disposable} from './Disposable.js';
import {default as Feature} from './Feature.js';
import {default as Geolocation} from './Geolocation.js';
import {default as Graticule} from './layer/Graticule.js';
import {default as Image} from './Image.js';
import {default as ImageWrapper} from './Image.js';
import {default as ImageCanvas} from './ImageCanvas.js';
import {default as ImageTile} from './ImageTile.js';
import {default as Kinetic} from './Kinetic.js';
import {default as Map} from './Map.js';
import {default as MapBrowserEvent} from './MapBrowserEvent.js';
import {default as MapBrowserEventHandler} from './MapBrowserEventHandler.js';
import {default as MapEvent} from './MapEvent.js';
import {default as Object} from './Object.js';
import {default as Observable} from './Observable.js';
import {default as Overlay} from './Overlay.js';
import {default as Tile} from './Tile.js';
import {default as TileQueue} from './TileQueue.js';
import {default as TileRange} from './TileRange.js';
import {default as VectorRenderTile} from './VectorRenderTile.js';
import {default as VectorTile} from './VectorTile.js';
import {default as View} from './View.js';
import {readFromSymbolizer, getSymbolizer} from './Style/StyleBuilder.js';

import * as turf from '@turf/turf';

import {default as GeoStylerOpenlayersParser} from './geostyler.js';
/* ------------------------------
   DEFAULT EXPORT — grouped API
   ------------------------------ */
export default {
  layer: layer,
  control: control,
  interaction: interaction,
  source: source,
  format: format,
  extent: extent,
  utils: utils,
  style: style,
  proj: proj,
  proj4: proj4,
  geom: geom,
  sphere: sphere,
  events: events,
  coordinate: coordinate,
  tilegrid: tilegrid,
  loadingstrategy: loadingstrategy,
  render: render,
  structs: {
    LRUCache: LRUCache
  },
  util: util,
  legend: legend,
  constants: {
    set,
    get,
    has,
    remove,
    all: constants.all, // safe read-only access
  },
  Collection:Collection,
  Disposable:Disposable,
  Feature:Feature,
  Geolocation:Geolocation,
  Graticule:Graticule,
  Image:Image,
  ImageWrapper:ImageWrapper,
  ImageCanvas:ImageCanvas,
  ImageTile:ImageTile,
  Kinetic:Kinetic,
  Map:Map,
  MapBrowserEvent:MapBrowserEvent,
  MapBrowserEventHandler:MapBrowserEventHandler,
  MapEvent:MapEvent,
  Object:Object,
  Observable:Observable,
  Overlay:Overlay,
  Tile:Tile,
  TileQueue:TileQueue,
  TileRange:TileRange,
  VectorRenderTile:VectorRenderTile,
  VectorTile:VectorTile,
  View:View,
  
  GeoStylerOpenlayersParser:GeoStylerOpenlayersParser,

  StyleBuilder: {
    readFromSymbolizer,
    getSymbolizer,
  },
  turf:turf, 
};
